/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { SearchKeysWithSearchOptionsRestResponse } from '../../models/search-keys-with-search-options-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetSearchKeysWithSearchOptions$Params {}

export function getSearchKeysWithSearchOptions(
  http: HttpClient,
  rootUrl: string,
  params?: GetSearchKeysWithSearchOptions$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchKeysWithSearchOptionsRestResponse>> {
  const rb = new RequestBuilder(rootUrl, getSearchKeysWithSearchOptions.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchKeysWithSearchOptionsRestResponse>;
    }),
  );
}

getSearchKeysWithSearchOptions.PATH = '/recourse-claim/searchKeysWithSearchOptions';
